export const ChooseDesign = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="21"
        viewBox="0 0 16 21"
        fill="none"
    >
        <path
            d="M15.1086 4.17483L11.7757 0.87959C11.4143 0.526529 10.8923 0.330383 10.4104 0.330383H2.21872C1.13452 0.330383 0.29126 1.19342 0.29126 2.21338V18.5327C0.29126 19.5918 1.13452 20.4157 2.21872 20.4157H13.7835C14.8275 20.4157 15.7109 19.5918 15.7109 18.5327V5.50862C15.7109 5.03787 15.47 4.52789 15.1086 4.17483ZM13.6229 5.3517H10.571V2.37029L13.6229 5.3517ZM2.21872 18.5327V2.21338H8.64359V6.2932C8.64359 6.8424 9.04514 7.23469 9.60732 7.23469H13.7835V18.5327H2.21872ZM3.50369 16.6497H12.4985V11.6283L11.5348 10.7261C11.334 10.5299 11.0529 10.5299 10.8521 10.7261L7.35861 14.139L5.7524 12.6091C5.55162 12.4129 5.27053 12.4129 5.06975 12.6091L3.50369 14.139V16.6497ZM5.43115 7.23469C4.34696 7.23469 3.50369 8.09773 3.50369 9.11769C3.50369 10.1769 4.34696 11.0007 5.43115 11.0007C6.47519 11.0007 7.35861 10.1769 7.35861 9.11769C7.35861 8.09773 6.47519 7.23469 5.43115 7.23469Z"
            fill="#202020"
            fillOpacity="0.7"
        />
    </svg>
)
